import React from "react";
import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/watchlist", label: "Watchlist", icon: "★" },
  { to: "/stockpicks", label: "Stockpicks", icon: "▦" },
  { to: "/search", label: "Search", icon: "⌕" },
  { to: "/ask", label: "Ask AI", icon: "✦", kind: "ask" },
  { to: "/portfolio", label: "Portfolio", icon: "◴" },
];

export default function BottomNav({ onAskList }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-800 bg-gray-900/90 backdrop-blur md:hidden [--bottom-nav:76px]">
      <div className="mx-auto max-w-2xl px-2 pt-2 pb-[calc(env(safe-area-inset-bottom)+8px)]">
        <nav className="grid grid-cols-5 gap-1">
          {tabs.map((t) => {
            // --- ASK AI SPECIAL ---
            if (t.kind === "ask") {
              return (
                <button
                  key={t.to}
                  type="button"
                  onClick={() => onAskList?.()}
                  className={[
                    "flex flex-col items-center justify-center gap-1 rounded-xl px-2 py-2 text-[11px]",
                    "text-gray-300 hover:bg-gray-800/60",
                  ].join(" ")}
                >
                  <div className="text-base leading-none">{t.icon}</div>
                  <div className="truncate">{t.label}</div>
                </button>
              );
            }

            // --- NORMAL TABS ---
            return (
              <NavLink
                key={t.to}
                to={t.to}
                className={({ isActive }) =>
                  [
                    "flex flex-col items-center justify-center gap-1 rounded-xl px-2 py-2 text-[11px]",
                    isActive
                      ? "bg-gray-800 text-white"
                      : "text-gray-300 hover:bg-gray-800/60",
                  ].join(" ")
                }
              >
                <div className="text-base leading-none">{t.icon}</div>
                <div className="truncate">{t.label}</div>
              </NavLink>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
